import React from 'react';
import { Navbar, Nav } from 'reactstrap';
import AuthService from '../externalauthentication/authservice';

export default props => {
  const logout = () => {
    const auth = new AuthService();
    auth.logout();
  };
  return (
    <div
      style={{
        width: '100%',
        marginBottom: '20px',
        background: '#80808c',
        borderBottomColor: '#44444a',
        borderBottomStyle: 'solid'
      }}
    >
      {/* <Navbar color="faded" light expand="md">
        <Nav
          navbar
          className="align-top"
          style={{ height: '35px', width: '100%' }}
        >
          <div style={{ width: '100%' }}>
            <div style={{float: 'left'}}>
             <img alt="logo" src="/images/bird-icon.png" style={{height: '65px'}} />
            </div>
            {!props.hideLogout && (
              <button
                className="btn btn-danger"
                style={{ float: 'right' }}
                onClick={() => logout()}
              >
                Log Out
              </button>
            )}
          </div>
        </Nav>
      </Navbar> */}
      <Navbar
        color="faded"
        light
        expand="md"
        className="container topNav"
        style={{ padding: 0, maxWidth: '90%', height: '70px' }}
      >
        <div className="navbar-brand mr-auto">
          <img
            alt="logo"
            src="/images/inst-parchment-logo-white.svg"
            style={{ height: '60px' }}
          />
        </div>
        <Nav navbar className="align-top">
          <li className="nav-item">
            {!props.hideLogout && (
              <button
                className="btn btn-danger"
                style={{ float: 'right' }}
                onClick={() => logout()}
              >
                Log Out
              </button>
            )}
          </li>
        </Nav>
      </Navbar>
    </div>
  );
};
